module.exports = __webpack_public_path__ + "static/media/day30_basics.d21fa77b.gif";